import { render, staticRenderFns } from "./RemoveServerDialog.vue?vue&type=template&id=4925b093&scoped=true&"
import script from "./RemoveServerDialog.vue?vue&type=script&lang=ts&"
export * from "./RemoveServerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925b093",
  null
  
)

export default component.exports